import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P77-E1',
    audio: 'img/FriendsPlus/Page77/Audio/audio-e1-p77.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page77/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page77/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/tieude-e1-p77.mp3' },
        { url: 'img/FriendsPlus/Page77/E1/3.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page77/E1/4.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/hinh1-e1-p77.mp3' },
        { url: 'img/FriendsPlus/Page77/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/hinh2-e1-p77.mp3' },
        { url: 'img/FriendsPlus/Page77/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/hinh3-e1-p77.mp3' },
        { url: 'img/FriendsPlus/Page77/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/hinh4-e1-p77.mp3' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P77-E2',
    audio: 'img/FriendsPlus/Page77/Audio/audio-e2-p77.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page77/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page77/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/tieude-e2-p77.mp3' },
        { url: 'img/FriendsPlus/Page77/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page77/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P77-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page77/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read the chant again. Circle the sound ee.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', padding: '0 5px' },
        listWords: [
          'Lo|ok up at t|he',//0_1
          'tr|ee.',//0_2
          'Wh|at c|an y|ou s|ee|?',//1
          'T|wo f|ee|t a|nd a ta|il.',//2
          'C|ou|nt th|em: o|ne, t|wo, t|hr|ee|!',//3
          'Wh|at’s in t|he gr|ee|n tr|ee|?',//4
          'Wh|at’s hidi|ng t|he|re?',//5
          'A mo|nk|ey wi|th a p|ie|ce of ch|ee|se,',//6
          'Th|at’s wh|at’s hi|di|ng the|re!',//7
        ],
        answers: ['1-2', '2-14', '3-6', '4-22', '5-12', '5-18', '7-24'],
        initialValue: [],
      },
      Layout: `
        <div style='display: flex;align-items: center;background-color: #fde9bc; padding: 20px;'>
          <div style='flex: 1; margin-right: 20px; color: #ec870e;text-align: center;'>
            <img src="img/FriendsPlus/Page77/E3/1.jpg">
            <div><input id='0' type='Circle' /> gr<span style="border: 2px solid rgb(0, 168, 236); border-radius: 50%; padding: 0px 5px;">ee</span> <input id='1' type='Circle' /></div>
            <div><input id='2' type='Circle' /></div>
            <div><input id='3' type='Circle' /></div>
            <div><input id='4' type='Circle' /></div>
          </div>
          <div style='flex: 1; margin-left: 20px; color: #ec870e;text-align: center;width: 375px;'>
            <img src="img/FriendsPlus/Page77/E3/2.jpg">
            <div><input id='5' type='Circle' /></div>
            <div><input id='6' type='Circle' /></div>
            <div><input id='7' type='Circle' /></div>
            <div><input id='8' type='Circle' /></div>
          </div>
        </div>
      `,
    },
  },
  4: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P77-E4',
    audio: 'img/FriendsPlus/Page77/Audio/audio-e4-p77.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page77/E4/Key/answerKey.png',
    isAllowSubmit: false,
    checkUppercase: true,
    maxLength: 2,
    textAlign: 'center',
    padding: 0,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page77/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page77/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page77/Audio/tieude-e4-p77.mp3' },
        { url: 'img/FriendsPlus/Page77/E4/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page77/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page77/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page77/E4/6.jpg', input: true, answer: "tr" },
        { url: 'img/FriendsPlus/Page77/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page77/E4/8.jpg', input: true, answer: "f" },
        { url: 'img/FriendsPlus/Page77/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page77/E4/10.jpg', input: true, answer: "t" },
        { url: 'img/FriendsPlus/Page77/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page77/E4/12.jpg', input: true, answer: "ch" },
        { url: 'img/FriendsPlus/Page77/E4/13.jpg' },
        { url: 'img/FriendsPlus/Page77/E4/14.jpg', input: true, answer: "se" },
        { url: 'img/FriendsPlus/Page77/E4/15.jpg' },
      ],
    ]
  },
  5: { // Exercise num
    unit: 'Unit 11',
    id: 'SB3-U11-P77-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page77/E5/1.jpg' }]],
  },
}

export default json;